module.exports = __webpack_public_path__ + "img/img_result-stand-03.ab842aa3.png";